import { Horse_show } from '../models/horse_show';
import { Horse_show_entry } from '../models/horse_show_entry';
import { Entry_type } from '../models/entry_type';

export class Entry_builder {

	schema_version: number;
	horse_show: Horse_show;
	horse_show_entry: Horse_show_entry;
	entry_type: Entry_type;
	billing_handled: boolean;
	competitions_entered: boolean;
	payee_completed: boolean;
	entry_finalized: boolean;

	// Bump this whenever a structural change to the stored data would cause
	// older persisted entries to crash or behave incorrectly. Any localStorage
	// entry that doesn't carry this exact version is discarded on load.
	static readonly CURRENT_SCHEMA_VERSION = 2;

	constructor() {
		this.schema_version = Entry_builder.CURRENT_SCHEMA_VERSION;
		this.horse_show = new Horse_show({});
		this.horse_show_entry = new Horse_show_entry({});
		this.entry_type = new Entry_type({});
		this.billing_handled = false;
		this.competitions_entered = false;
		this.payee_completed = false;
		this.entry_finalized = false;
	}

}